var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_vm._m(0),_c('wx-config',{on:{"wxConfigReady":_vm.wxConfigReady}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text"},[_vm._v("正在启动微信支付，请稍后。。。"),_c('br'),_c('br'),_vm._v("若未弹出支付功能请重新下单或与云柑社区客服联系。")])
}]

export { render, staticRenderFns }